import { css, SerializedStyles } from '@emotion/core'

import { Position } from '../types'

export const getIconPositionStyle = (position: Position, withIconMargin?: boolean): SerializedStyles | string => {
  if (!withIconMargin || position === 'left') {
    return ''
  }

  return css`
    margin-left: auto;
  `
}
